/**
 * Vuex State for the resources section blog items (travel health)
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2020
 */

import { DataExplorerApi } from '@/services/api-data-explorer.js';

// Local state -----------------------------------------------------
export const state = getDefaultState();

// Synchronous mutations of the local state -------------------------
export const mutations = {
  updateCurrentDownload(state, { url, type }) {
    state.current[type] = url;
  },

  resetState(state, defaultState) {
    state.current = { ...defaultState.current };
  },
};

// Async CRUD actions against the api ------------------------------
export const actions = {
  /**
   * Create a new download
   * @param {Object} context
   * @param {Function} context.commit
   * @param {Object} context.state
   * @param {'excel'|'gsheet'} type
   * @returns {Promise}
   */
  store({ commit, state }, type) {
    // if we've already have downloads don't request them again
    if (state.current[type]) {
      return Promise.resolve();
    }

    return DataExplorerApi.store(type)
      .then((response) => {
        if (response.download_url) {
          commit('updateCurrentDownload', {
            url: response.download_url,
            type: type,
          });
        }
      })
      .catch(() => {
        commit('updateCurrentDownload', { url: '', type: type });

        this.$store.dispatch('notifications/create', {
          type: 'error',
          message: 'We are unable to fetch your data explorer file. Please try again.',
        });
      });
  },

  /**
   * Sets the state back to the default values
   * @returns {Promise}
   */
  reset({ commit }) {
    commit('resetState', getDefaultState());
  },
};

/// ///

function getDefaultState() {
  return {
    current: {
      excel: '',
      gsheet: '',
    },
  };
}
